import type { FC } from "react";

import type { IProofStripCell } from "~/feature/getUpdates/types";

import * as Styled from "./ProofStrip.styles";

interface IProofStripProps {
  cells: IProofStripCell[] | null;
  ink?: boolean;
}

export const ProofStrip: FC<IProofStripProps> = ({ cells, ink }) => {
  if (!cells) return null;

  return (
    <Styled.Root>
      <Styled.Eyebrow $ink={ink}>
        <Styled.LiveDot />
        LIVE COVERAGE
      </Styled.Eyebrow>
      <Styled.Cells $ink={ink}>
        {cells.map(({ value, label }) => (
          <Styled.Cell key={label} $ink={ink}>
            <Styled.CellValue $ink={ink}>{value}</Styled.CellValue>
            <Styled.CellLabel $ink={ink}>{label}</Styled.CellLabel>
          </Styled.Cell>
        ))}
      </Styled.Cells>
    </Styled.Root>
  );
};
